import styled from "@emotion/styled";

export const ButtonGroup = styled.div`
  display: flex;
  gap: var(--space-3);
  align-items: baseline;
`;
